export const getSwitchToExpertMenuStyles = () => ({
  switchButton: {
    '&.btn': {
      paddingLeft: '8px',
      border: 'none',
      fontWeight: 'normal',
      fontSize: '14px',
      width: '100%',
      textAlign: 'left',
    },
  },
});
